export type ChartColorTuple = [
  // string,
  // string,
  // string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
]; // 12 shades

export type ChartColor = "blue" | "green" | "orange" | "violet" | "yellow";

export const blue: ChartColorTuple = [
  // "#FFFFFF",
  // "#ECECFA",
  // "#D8D8F4",
  "#C5C5EF",
  "#B1B1EA",
  "#8B8BDF",
  "#6464D5",
  "#3D3DCA",
  "#3131A1",
  "#252579",
  "#181851",
  "#12123D",
  "#0C0C28",
  "#000000",
];

export const green: ChartColorTuple = [
  // "#F6FFFE",
  // "#EAFFFD",
  // "#DDFCF9",
  "#CBF4F0",
  "#B2E7E1",
  "#A0DDD7",
  "#78C7BE",
  "#5EAFA7",
  "#4A9A92",
  "#32887F",
  "#35857C",
  "#3B786F",
  "#184841",
  "#0A322C",
];

export const orange: ChartColorTuple = [
  // "#FEF7F3",
  // "#FCEAE0",
  // "#FADECE",
  "#F8D1BB",
  "#F6C4A9",
  "#F3AB84",
  "#EF925F",
  "#EB793A",
  "#CC6830",
  "#AD5626",
  "#8F451C",
  "#703312",
  "#602B0D",
  "#512208",
];

export const violet: ChartColorTuple = [
  // // "#E6E6EB",
  // // "#F2F2F2",
  // "#EEEEEE",
  "#9C9CAD",
  "#DBDBE5",
  "#6B6B85",
  "#525270",
  "#39395C",
  "#525277",
  "#484874",
  "#212147",
  "#262648",
  "#080833",
  "#040426",
];

export const yellow: ChartColorTuple = [
  // "#FFF3DE",
  // "#FFECCC",
  // "#FFE6BB",
  "#FFDC9F",
  "#FFD58B",
  "#FAC56A",
  "#F2B347",
  "#F0A729",
  "#DA8E0B",
  "#C17A00",
  "#9C6300",
  "#724A06",
  "#603F06",
  "#503507",
];
